// Mock data for AR Danışmanlık A.Ş. site

export const BRAND = {
  name: "AR DANIŞMANLIK A.Ş.",
  shortName: "AR Danışmanlık",
  logoUrl: "https://customer-assets.emergentagent.com/job_76c6093c-1a3d-4598-bfba-931e1a4ba51f/artifacts/l112ktic_AR_Logo.png",
  tagline: "Yatırım • Teşvik • Danışmanlık",
  years: 21,
  phone: "+90 (212) 000 00 00",
  phoneRaw: "+902120000000",
  whatsapp: "+905550000000",
  whatsappRaw: "905550000000",
  email: "info@ardanismanlik.com.tr",
  address: "Levent Mah. Büyükdere Cad. No: 00 Kat: 00 Şişli / İstanbul",
  socials: {
    linkedin: "#",
    instagram: "#",
    twitter: "#"
  }
};

export const NAV = [
  { label: "ANASAYFA", path: "/" },
  { label: "HAKKIMIZDA", path: "/hakkimizda" },
  { label: "HİZMETLERİMİZ", path: "/hizmetlerimiz" },
  { label: "PROGRAMLAR", path: "/programlar" },
  { label: "BİZE ULAŞIN", path: "/iletisim" }
];

export const HERO_SLIDES = [
  {
    kicker: "YATIRIM",
    title: "Geleceğinizi şekillendirmeye birlikte başlayalım",
    subtitle: "Teşvik ve Danışmanlık",
    cta: { label: "Hizmetlerimiz", path: "/hizmetlerimiz" }
  },
  {
    kicker: "TEŞVİK",
    title: "İşletmenizin büyümesini en üst düzeye çıkarıyoruz",
    subtitle: "Devlet teşvikleri ve vergi avantajları",
    cta: { label: "Teşvik Analizi", path: "/hizmetlerimiz" }
  },
  {
    kicker: "DANIŞMANLIK",
    title: "Her adımda yanınızda olan çözüm ortağınız",
    subtitle: "Başvurudan stratejiye, uçtan uca destek",
    cta: { label: "İletişime Geç", path: "/iletisim" }
  }
];

// Royalty-free corporate videos (used as background in hero)
export const HERO_VIDEO = {
  sources: [
    "https://assets.mixkit.co/videos/4830/4830-720.mp4",
    "https://assets.mixkit.co/videos/39766/39766-720.mp4",
    "https://assets.mixkit.co/videos/18313/18313-720.mp4"
  ],
  poster: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1920&q=70"
};

export const FEATURE_CARDS = [
  {
    icon: "TrendingUp",
    title: "Yatırım Teşvik Danışmanlığı",
    text: "İşletmenizin büyümesini desteklemek için devlet teşvikleri, vergi avantajları ve teşvik programları konusunda uzmanlaşmış bir ekiple size rehberlik ediyoruz. Sizin için en uygun teşvikleri belirleyerek işletmenizin potansiyelini en üst düzeye çıkarıyoruz."
  },
  {
    icon: "FileCheck2",
    title: "Danışmanlık Süreci",
    text: "Müşteri memnuniyeti odaklı yaklaşımımızla, işletmenizin ihtiyaçlarını anlamak ve en etkili çözümleri sunmak için size özel bir danışmanlık süreci sunuyoruz. Adım adım rehberlik ederek, işletmenizin büyümesini hedefliyoruz."
  },
  {
    icon: "Scale",
    title: "Neden Bizi Seçmelisiniz?",
    text: "Deneyimli ve uzman kadromuzla işletmenizin ihtiyaçlarına özel çözümler sunuyoruz. Müşteri memnuniyeti odaklı yaklaşımımızla size en iyi hizmeti sunuyoruz. Başarı hikayelerimiz ve referanslarımızla güvenilirliğimizi kanıtlıyoruz."
  },
  {
    icon: "Coffee",
    title: "İletişim",
    text: "AR Danışmanlık'a ulaşmak ve işletmenizin büyümesine nasıl katkıda bulunabileceğimizi öğrenmek için bizimle iletişime geçmekten çekinmeyin. Size en uygun çözümleri bulmak için buradayız."
  }
];

export const STATS = [
  { value: 3681, suffix: "+", label: "Yatırım Teşvik Belgesi" },
  { value: 265, suffix: "+", label: "TÜBİTAK Projesi" },
  { value: 195, suffix: "+", label: "KOSGEB Projesi" }
];

export const SERVICES = [
  { slug: "yatirim-tesvik-belgesi", title: "Yatırım Teşvik Belgesi Danışmanlığı", short: "Devlet teşvikleri ile yatırımlarınızı güvence altına alın." },
  { slug: "ihracat-destekleri", title: "Ticaret Bakanlığı İhracat Destekleri Danışmanlığı", short: "Global pazarlara açılmanız için destek süreçleri." },
  { slug: "tubitak-arge", title: "TÜBİTAK Ar-Ge Proje Danışmanlığı", short: "Ar-Ge projelerinizin finansmanı için uçtan uca çözüm." },
  { slug: "turquality", title: "TURQUALITY Danışmanlığı", short: "Marka değerinizi global ölçekte büyütün." },
  { slug: "kosgeb", title: "KOSGEB Proje Danışmanlığı", short: "KOBİ destek programları uzmanlığı." },
  { slug: "arge-tasarim-merkezi", title: "Ar-Ge / Tasarım Merkezi Danışmanlığı", short: "Merkez kuruluşu ve tam süreç yönetimi." },
  { slug: "dahilde-isleme", title: "Dahilde İşleme İzin Belgesi Danışmanlığı", short: "İhracat odaklı ithalat avantajları." },
  { slug: "kalkinma-ajanslari", title: "Kalkınma Ajansları Proje Danışmanlığı", short: "Bölgesel hibe ve destek projeleri." },
  { slug: "turizm-belgeleri", title: "Turizm Yatırım / İşletme Belgeleri / Kapasite Raporu", short: "Turizm sektörüne özel belge ve raporlama." }
];

export const PROCESS_STEPS = [
  {
    title: "Teşvik Analizi ve Değerlendirme",
    desc: "İşletmenizin ihtiyaçlarına ve hedeflerine en uygun teşvik programlarını belirlemek için detaylı bir analiz yapıyoruz."
  },
  {
    title: "Başvuru Süreci Yönetimi",
    desc: "Teşvik başvurusu sürecini başından sonuna kadar titizlikle yönetiyoruz; gereken belgelerin hazırlanmasından başvurunun takibine kadar her adımda sizinle birlikteyiz."
  },
  {
    title: "Teşviklerden Yararlanma Stratejisi Geliştirme",
    desc: "İşletmenizin uzun vadeli büyüme hedeflerine ulaşmanızı sağlayacak teşvik stratejileri oluşturuyoruz."
  }
];

export const PROGRAMS = [
  { code: "1501", title: "TÜBİTAK 1501 Sanayi Ar-Ge Destek Programı", body: "Sanayi kuruluşlarının Ar-Ge faaliyetlerinin desteklenmesi." },
  { code: "1505", title: "TÜBİTAK 1505 Üniversite-Sanayi İşbirliği", body: "Üniversite ile sanayi arasındaki ortak projeler." },
  { code: "1507", title: "TÜBİTAK 1507 KOBİ Ar-Ge Başlangıç", body: "KOBİ'lerin Ar-Ge kültürünün oluşturulması." },
  { code: "KOSGEB", title: "KOSGEB İşletme Geliştirme Destek Programı", body: "İşletmelerin rekabet gücünün artırılması." },
  { code: "DİİB", title: "Dahilde İşleme İzin Belgesi", body: "İhracata yönelik üretim için ithalat imkânları." },
  { code: "AJANS", title: "Kalkınma Ajansları Destekleri", body: "Bölgesel kalkınma odaklı hibe programları." }
];

export const TESTIMONIALS = [
  { name: "M. Erdem", role: "CEO, Mavi Otomotiv", text: "Yatırım sürecimizde gösterdikleri profesyonellik ve teşvik belgesi konusundaki uzmanlıkları sayesinde hedeflerimize zamanında ulaştık." },
  { name: "A. Yıldız", role: "Genel Müdür, Yıldız Tekstil", text: "Ar-Ge projelerimizde baştan sona yanımızdaydılar. Ekip son derece tecrübeli ve çözüm odaklı." },
  { name: "S. Kavuk", role: "Kurucu, TeknoMakine", text: "TÜBİTAK başvurumuzu ilk seferde onaylattık. Tavsiye ediyorum." }
];
